export default __webpack_public_path__ + "static/media/sharpL.d29fe8d0.png";